import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import type { ComponentProps } from 'react';
import { isDevelopment } from '@/lib/general-helpers.ts';
export const ThirdPartyScriptWrapper = t0 => {
  const $ = _c(6);
  const {
    id,
    scriptContent,
    scriptOptions,
    ignoreInDevelopment: t1
  } = t0;
  const ignoreInDevelopment = t1 === undefined ? true : t1;
  if (ignoreInDevelopment && isDevelopment()) {
    return null;
  }
  let t2;
  if ($[0] !== scriptContent) {
    t2 = {
      __html: scriptContent
    };
    $[0] = scriptContent;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== id || $[3] !== scriptOptions || $[4] !== t2) {
    t3 = <Script id={id} dangerouslySetInnerHTML={t2} {...scriptOptions} />;
    $[2] = id;
    $[3] = scriptOptions;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};